var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box box--red"},[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t('boxes.duration.title')))]),_vm._v(" "),_c('span',{staticClass:"fz--large"},[_vm._v(_vm._s(_vm.visitors.averageTimeElapsed))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d612a1cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Metrics/components/boxes/AverageTime.vue
// module id = 1490
// module chunks = 1